// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__+GSFX","checkmark":"Checkbox_checkmark__rZJsL","indeterminate":"Checkbox_indeterminate__EEK89","container":"Checkbox_container__ZJ+qG"};